// Core components
import { Component } from "@angular/core";

// Third party components
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from 'src/app/shared/services/config.service';

// Custom components

@Component({
  selector: 'app-formly-slide-toggle-type',
  templateUrl: "./slide-toggle-type.component.html",
  styleUrls: ["./slide-toggle-type.component.scss"]
})

export class SlideToggleTypeComponent extends FieldType {

  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private translateService: TranslateService,
    private toastrService: ToastrService,
  ) {
    super();
  }

  /**
   * Handle change event
   *
   * @since 1.0.0
   *
   */
  onChange(checked: boolean): void {
    const key = this.field.key as string;
    if (typeof this.model[key] !== "undefined") {
      this.model[key] = checked;
    }
  }
}
